import React, { useContext, useEffect, useState } from "react";
import styles from "./OrganizerPopup.module.css";
import closebutton from "../../assests/closebutton.svg";
import ReactPlayer from "react-player";
import ContactUsFooter from "../ContactUsFooter/ContactUsFooter";
import Context from "../../context/Context";
import { useNavigate } from "react-router";
import Insta from "../../assests/instagram.png";
import fbLogo from "../../assests/share/fbLogo.svg";
import twitterLogo from "../../assests/share/twitter.svg";
import { isEmpty } from "lodash";
export default function OrganizerPopup({ setOrganizerPopup, data }) {
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  const { details } = useContext(Context);
  const navigate = useNavigate();

  const profileHelpNavigate = () => {
    navigate(`/profile/help`);
  };
  return (
    <div className={styles.popupWrapper}>
      <div
        className={`h-full w-full bg-black bg-opacity-40 max-w-[425px] mx-auto pt-[50px] backdrop-blur-sm transform transition-transform ease-in-out duration-300
      ${show ? "translate-y-0" : "translate-y-full"}
      `}
      >
        {" "}
        <div className={`no-scrollbar ${styles.parentDiv}`}>
          <div className="flex justify-between items-center w-[100%]  sticky top-0 left-0 bg-black ">
            <p className="text-large-bold p-[20px]">{data?.name}</p>
            <img
              src={closebutton}
              onClick={() => setOrganizerPopup(false)}
              className=" hover:cursor-pointer p-[20px]"
            />
          </div>
          <div className=" w-[100%]  flex flex-col  items-center justify-start pt-[16px] px-[20px] text-center">
            <img
              className=" w-[80px] h-auto object-contain shrink-0"
              src={data?.logo}
              alt=""
            />
            <p className="judgesName shrink-0 ">{data?.tagline}</p>
            <div className="flex gap-[10px]">
              {data?.socialmedialink?.facebook && (
                <a href={data?.socialmedialink?.facebook} target="_blank">
                  <img
                    className=" cursor-pointer object-cover w-[24px] h-[24px] mt-[8px]"
                    src={fbLogo}
                    alt=""
                  />
                </a>
              )}
              {data?.socialmedialink?.instagram && (
                <a href={data?.socialmedialink?.instagram} target="_blank">
                  <img
                    className=" cursor-pointer object-cover w-[24px] h-[24px] mt-[8px]"
                    src={Insta}
                    alt=""
                  />
                </a>
              )}
              {data?.socialmedialink?.twitter && (
                <a href={data?.socialmedialink?.twitter} target="_blank">
                  <img
                    className=" cursor-pointer object-cover w-[24px] h-[24px] mt-[8px]"
                    src={twitterLogo}
                    alt=""
                  />
                </a>
              )}
            </div>
            <pre className="mt-[8px] text-regular text-[#CDCDCD]">
              {data?.description}
            </pre>
          </div>
          {!isEmpty(data?.media) && (
            <div className="px-[20px] mt-[30px] ">
              <p className="text-medium mb-[20px]">Gallery</p>
              <div className="flex flex-col gap-[30px]">
                {data?.media?.map((obj) => {
                  return (
                    <>
                      {obj.fileType?.startsWith("video") ? (
                        <ReactPlayer
                          config={{
                            file: {
                              attributes: { controlsList: "nodownload" },
                            },
                          }}
                          playing={false}
                          controls={true}
                          width="100%"
                          height="100%"
                          url={obj.fileUrl}
                        />
                      ) : (
                        <img
                          src={obj.fileUrl}
                          alt=""
                          className="h-[100%] w-[100%] mx-auto object-contain"
                        />
                      )}
                    </>
                  );
                })}
              </div>
            </div>
          )}
          <div className="seperator mt-[30px]" />
          <ContactUsFooter profileHelpNavigate={profileHelpNavigate} />
        </div>
      </div>
    </div>
  );
}
